import { Component } from 'react';
import './App.scss';

class App extends Component<{}, {}> {
  render() {
    return (
    <div className="App">
      <img src="./logo.jpg"/>
      <div className="Tagline">A Religious Bookstore</div>
      <MissionComponent />
      <LocationHours />
      <PlaceOrder />
    </div>
    );
  }
}

class MissionComponent extends Component<{}, {}> {
  render() {
    return (
      <div className="Mission">
        <h1>Our Mission Statement</h1>
        <img className="SplashImage" src="./splash.png"/>
        <p>St. Joseph's Workshop is an apostolic initiative established to promote a greater understanding and appreciation of ones faith and spiritual life. It aims to achieve this through quality publications and other educational, historical, devotional and inspirational materials of Christian content and message.</p>
      </div>
    );
  }
}

interface LocationProps {
  address1: string;
  address2: string;
  hours: string;
}

class Location extends Component<LocationProps, {}> {
  render() {
    return (
      <div className="Location">
        <div className="Address">
          <div>{this.props.address1}</div>
          <div>{this.props.address2}</div>
        </div>
        <div className="Hours">
          {this.props.hours}
        </div>
      </div>
    );
  }
}

class LocationHours extends Component<{}, {}> {
  render() {
    return (
      <div className="LocationHours">
      <h1>Store Locations and Hours</h1>
      <div className="Locations">
        <Location
          address1="259 Traders Blvd. E Unit #12"
          address2="Mississauga, ON  L4Z 2E5"
          hours="Wednesday to Friday: 1:00 pm to 5:00 pm; Saturday: 1:00 pm to 5:00 pm"
        />
        <Location
          address1="3375 Thomas St. #5"
          address2="Mississauga, ON  L5M 2E5"
          hours="Monday and Tuesday: 1:00 pm to 5:00 pm – limited to pickup &amp; only by appointment"
        />
      </div>
      <div className="WalkIns">
        Open for walk-in, limited capacity
      </div>
    </div>
    );
  }
}

class PlaceOrder extends Component<{}, {}> {
  render() {
    return (
      <div className="PlaceOrder">
        <h1>Placing an Order</h1>
        <p>
          <div>
            <strong>Call Us</strong><br/>
            <ul>
              <li><a href="tel: 9055688777">905-568-8777</a> or <a href="tel:4166022217">416-602-2217</a> (all days)</li>
              <li><a href="tel: 9059971228">905-997-1228</a> (Thomas only on Mondays & Tuesdays)</li>
            </ul>
          </div>
          <br/>
          <div>
          <strong>Email Us</strong><br/>
            <div><a href="mailto:sockeemendiola@gmail.com">sockeemendiola@gmail.com</a></div> 
            {/* <div><a href="mailto: info@st-josephsworkshop.com">info@st-josephsworkshop.com</a></div> */}
          </div>
        </p>
      </div>
    );
  }
}

export default App;
